import { Box, useTheme } from '@mui/material';
import ClampLines from 'react-clamp-lines';
import { DateTime } from 'luxon';
import { EVENT_TITLE } from '@src/enums/event-title-enum';
import Image from 'next/image';
import Paper from '@src/components/paper/paper';
import React from 'react';
import styled from '@emotion/styled';
import { useTrackEvent } from '@src/hooks/useTrackEvent';

const StyledClamp = styled(ClampLines)`
    color: ${(props: { color: string }) => props.color}
    font-size: 12px;
`;

const StyledDateFont = styled.span`
    color: ${(props: { color: string }) => props.color}
    font-size: 12px;
`;

const StyledLink = styled.a`
    text-decoration: none;
`;

const StyledTitle = styled.span`
    font-weight: bold;
    height: 40px;
    margin: 4px 0px 6px 0px;
    overflow: hidden;
`;

const BlogCard = ({ blog, location }) => {
    const trackEvent = useTrackEvent();
    const theme = useTheme();

    const trackGoToBlog = (blog) => () => {
        trackEvent(EVENT_TITLE.BlogLink, { location, objectId: blog.slug });
    };

    return (
        <StyledLink onClick={trackGoToBlog(blog)} href={`/blog/${blog.slug}`} data-testid={`blog-card`} key={blog.slug}>
            <Paper>
                <Box display='grid' gridTemplateColumns='100px 1fr' gap='15px'>
                    <Box display='flex' alignItems='center'>
                        <Image
                            alt='blog-main-image'
                            height={100}
                            width={100}
                            objectFit='contain'
                            src={blog.seo?.opengraphImage?.sourceUrl || '/images/tractorzoom-diesel.png'}
                        />
                    </Box>
                    <Box display='flex' flexDirection='column' alignItems='flex-start'>
                        <StyledDateFont color={theme.palette.secondary.light}>
                            {`${DateTime.fromISO(blog.dateGmt).toFormat('MMM. dd, yyyy')} \u2022 ${
                                blog.categories?.nodes[0]?.name
                            }`}
                        </StyledDateFont>
                        <StyledTitle>{blog.title}</StyledTitle>
                        {blog.seo?.metaDesc && (
                            <StyledClamp
                                id={`blog-description-${blog.slug}`}
                                color={theme.palette.secondary.light}
                                buttons={false}
                                text={blog.seo.metaDesc}
                                lines={2}
                                ellipsis='...'
                            />
                        )}
                    </Box>
                </Box>
            </Paper>
        </StyledLink>
    );
};

export default BlogCard;
